/**
 * EmptyState
 * First-run state, shown before a user creates their first project.
 * Props:
 *   onCreateProject()
 */
export default function EmptyState({ onCreateProject }) {
  return (
    <div style={{ maxWidth: 420, margin: "40px auto", textAlign: "center" }}>
      <p style={{ fontSize: "var(--text-lg)", fontWeight: 500, margin: "16px 0 6px" }}>No projects yet</p>
      <p style={{ fontSize: "var(--text-sm)", color: "var(--text-secondary)", margin: "0 0 20px" }}>
        Create a project to start monitoring iCal feeds and get webhooks when they change.
      </p>
      <button className="ical-btn ical-btn-primary" onClick={onCreateProject}>
        + Create your first project
      </button>
    </div>
  );
}
